<template>
   <div class="transactionsLog">
	<div class="container">
		<div class="row justify-content-center">
			<div class="col-md-12">
			<div class="card">
				<div class="card-header bg-white border-0">
					<div class="row align-items-center">
						<div class="col-8">
							<h3 class="mb-0 text-left">{{$t("forms.transactionsLog.title")}}</h3>
						</div>
                        <div class="col-4 text-right">
							<router-link class="btn btn-sm btn-primary" replace to="/profile">{{$t('actions.back')}}</router-link>
						</div>
					</div>
					<hr>
				</div>
                <div class="card-body">
                    <div v-show="isLoading">
                        <div class="spinner-border text-warning" role="status"><span class="sr-only">{{$t('actions.loading')}}</span></div>
                    </div>
                    <div class="row justify-content-center" v-show="!isLoading">
                        <div class="col-lg-12 col-md-12">
                            <table class="table services-table">
                            <thead class="thead-light">
                                <tr>
                                    <th class="bt-0">{{$t("forms.transactionsLog.operationTableHeder")}}</th>
                                    <th scope="col">{{$t("forms.transactionsLog.dateTableHeder")}}</th>
                                    <th scope="col">{{$t("forms.transactionsLog.descriptionTableHeder")}}</th>
                                    <th scope="col">{{$t("forms.transactionsLog.amountTableHeder")}}</th>
                                    <th scope="col">{{$t("forms.transactionsLog.valueTableHeder")}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in logEntries" :key="item.guid">
                                    <td scope="row">
                                        <span v-show="item.operation == 0 || item.operation == 10 || item.operation == 20">Add</span>
                                        <span v-show="item.operation == 30">Remove</span>
                                    </td>
                                    <td>{{item.timestampMoment.format('DD MMM @ hh:mm')}}</td>
                                    <td>{{item.description}}</td>
                                    <td>{{item.delta | round(2, true)}}</td>
                                    <td>{{item.newValue | round(2, true)}} {{item.currencyCode}}</td>
                                </tr>
                            </tbody>
                            </table> 
                        </div>        
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import { round } from "./../../utils/filters.js";
import ApiService from './../../services/apiService.js';
import moment from 'moment';

export default {
    data() {
        return {
            isLoading: true,
            logEntries: [],
            reservations: [],		
        };
    },
    computed: {

    },
    filters: {
        round: round
    },
    created() {
        console.log('created: ', this)
        let userGuid = this.$store.state.account.guid;
        let websiteGuid = this.$store.state.account.websiteGuid;
        ApiService.getClientAccountTransactions(websiteGuid, userGuid).then(response => {
            if(response.data.success) {
                console.log(response.data.result);
                this.logEntries = response.data.result.logEntries;
                this.logEntries.forEach(item => {
                    item.timestampMoment = moment(item.timestamp);
                });
                this.isLoading = false;
            }
        })
        console.log(userGuid, websiteGuid);

        // this.getClientReservations().then(result=>{
        //     console.log("getClientReservations result:", result);
            
        //     result.forEach(item => {
        //         item.pickupDateTimeMoment = moment(item.pickupDateTime);
        //        // console.log(item);
        //     });

        //     this.reservations = result
        //     this.isLoading = false;
        // });

	// this.getUserProfile().then(result=>{		
	// 	this.email = result.email;
	// 	this.firstName = result.firstName;
	// 	this.lastName = result.lastName;
	// 	this.phone = result.phoneNumber;
	// 	this.defaultCar = result.defaultCar;
	// 	this.currency = result.currency;
	// 	this.instructionsForPlanner = result.instructionsForDispatcher;
	// 	this.instructionsForDriver = result.instructionsForDriver;
	// 	if(result.otherCars)
	// 		this.otherCars = result.otherCars.join(", ");

	// 	if(result.subscription)
	// 		this.subscription = result.subscription;

	// 	if(result.remainingCredit)
	// 		this.remainingCredit = result.remainingCredit;

	// 	if(result.pickupAddress)
	// 		this.address = result.pickupAddress.formatterAddress;

	// 	this.isLoading = false;
	// });
  },
  methods: {
    ...mapActions("account", ["getClientReservations"]),
  }
}
</script>

<style>
    .services-table tbody td {
        font-size: 14px;
        vertical-align: middle;
    }
</style>